import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../../graphql";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Tabs,
  Typography,
  Spin,
  Row,
  Col,
  Input,
  message,
  Table,
  Icon,
  Button,
  Popconfirm,
  Form,
  Select,
  DatePicker,
} from "antd";
import Container from "../../../../components/user/Container";
import { changeFormatdate, checkMoreThanLess } from "../../../../utils/formatdate";
import { sumTotalAbstainDate } from "../../../../utils/abstainTime";
import { alertMessage } from '../../../../utils/message';
import { UrlAbstainTime, getToken } from '../../../../utils/auth';
import axios from 'axios';
import { apiKeyNews } from '../../../../utils/apiKey'
import moment from "moment";

const { TabPane } = Tabs;
const { Text, Title } = Typography;
const { Option } = Select;

const newsDataProfile = "";

class Dashboard extends Component {
   state = {
      loading: true,
      loadingFullpage: true,
      dataTalbe:[],
      columns: [
         {
         // title: 'เลขที่เอกสาร',
         title: "เลขที่เอกสาร",
         dataIndex: "documentNo",
         width: 150,
         // align:'center',
         render: (item, record, index) => <span>{item}</span>,
         // render: (item, record, index) => <span>{ item }</span>
         },
         {
         title: "วันที่ยื่นเรื่อง",
         dataIndex: "createdAt",
         width: "150px",
         align: "center",
         render: (item, record, index) => (
            <span>{ changeFormatdate(item) }</span>
         ),
         },
         {
         title: "จำนวนวันที่ขอแก้ไข",
         dataIndex: "totalAbstainDate",
         width: "150px",
         align: "center",
         render: (item, record, index) => (
            // <span>{sumTotalAbstainDate(record.tbAbstainTimeDt)}</span>
            <span>{record.tbAbstainTimeDt.length}</span>
         
         ),
         },
         {
         title: "สถานะ",
         dataIndex: "approveStatusName",
         align: "center",
         // render: (item, record, index) => <span>{}</span>
         width: "130px",
         render: (item, record, index) => (
               <span>{ item }</span>
         ),
         },
         
         {
         title: "จัดการ",
         dataIndex: "7",
         align: "center",
         width: 100,
        // fixed: "right",
         render: (item, record, index) => {
            return (
               <>
               <Link
                  to={{
                     pathname: record.abTimeHdId
                     ? "/AbstainTime/Form/edit/" + record.abTimeHdId
                     : "",
                  }}
               >
                  <Icon type="form" className="mr-2" style={{ color: "#000" }} />
                  {/* { record.wdLeaveId } */}
               </Link>
               </>
            );
         },
         },
      ],
      offset: 0,
      limit: 10,
      pagination: {
         total: 10,
      },
      disabledDateStart: moment(new Date()).add(-1, "year"),
      endStartValues: moment(new Date()).add(1, "year"),
      valueStatus: "A",
      preLoadSubmit: false,
      formValue: null,
      dropdownLeaveType: [],
      currentPage: 1,
      loginPerson: [],
   };

   dropdownLeaveType = async () => {
   const { client, location, match } = this.props;
   const { empCode } = this.state;
   const { data, errors } = await client.query({
      query: Queries.dropdownLeaveType,
      variables: {
      // empCode
      isReqByEmp: true,
      },
   });

   console.log("data.dropdownLeaveType", data.dropdownLeaveType);

   if (data.dropdownLeaveType) {
      await this.setState({
      dropdownLeaveType: data.dropdownLeaveType,
      });
   }
   };

   fetchProfile = async () => {
   try {
      const { client } = this.props;
      const { data } = await client.query({
      query: Queries.fetchProfile,
      });

      await this.setState({
      loginPerson: data.fetchProfile,
      });
      // return data.fetchProfile

      console.log("FETCH PROFILE:", data.fetchProfile);
      console.log("FETCH emp:", data.fetchProfile.employeeCodes[0]);
   } catch (e) {}
   };

   paginationChange = async (e) => {
      const { formValue, empCode } = this.state;
      const { form, afterSubmit, client } = this.props;
      // await e.preventDefault()

      console.log("pagination e",e.current)
      // console.log("pagination values",values)

      form.validateFields(async (err, values) => {
         console.log("values pagination", values);
         await this.setState({
         formValue: values,
         });

         console.log("paginationChange formvalue", values);

         if (!err) {
         try {
            let offset = 0;
            if (e.current === 1) {
               offset = 0;
            } else {
               offset = e.current - 1 + "0";
            }

            console.log("pagination e offset",offset)
            await this.setState({
               pageData: {
               offset: parseInt(offset),
               limit: 10,
               },
            });
            await this.setState({
               pageData: {
               offset: parseInt(offset),
               limit: 10,
               },
               currentPage: e.current,
            });

            // await this.fetchListPost()
            if (formValue) {
               console.log("paginationChange formvalue!!", values);
               await this.fetchListAbstainTimeForEmployeeSearch(values);
            } else {
               await this.fetchListAbstainTimeForEmployee();
            }
         } catch (error) {
            console.log("error", error);
         }
         }
      });
   };

   handleSubmit = async (e) => {
      const { form, afterSubmit, client } = this.props;
      const { telNo, otpToken, refCode, loginPerson } = this.state;

      await e.preventDefault();
    form.validateFields(async (err, values) => {
      console.log("values Submit", values);

      if (!err) {
         this.fetchListAbstainTimeForEmployeeSearchPagi(values)
   };
})
   }

   clearInput = async () => {
      await this.setState({
         formValue: null,
         disabledDateStart: moment(new Date()).add(-1, "year"),
         endStartValues: moment(new Date()).add(1, "year"),
      });
      this.props.form.resetFields();
   };

   fetchDropDownMasterData = async (dropDownType) => {
      const { client, location, match } = this.props;
      const { empCode,loadingFullpage } = this.state;

      let dropDownRetrue = [];
      try {
         const { data, errors } = await client.query({
         query: Queries.fetchDropDownMasterData,
         variables: {
            dropDownType,
         },
         });

         await data.fetchDropDownMasterData.map((values, keys) => {
         dropDownRetrue.push({
            value: values.id,
            label: values.label,
         });
         });

         await this.setState({
         ["dropDownType" + dropDownType]: dropDownRetrue,
         loadingFullpage:false
         });

         if (dropDownType == "leaveYear"){
         if(dropDownRetrue && dropDownRetrue?.length > 0){
            await this.setState({
            ddStartYear:dropDownRetrue[0].value,
            ddEndYear:dropDownRetrue[dropDownRetrue?.length-1].value,
            startYear: dropDownRetrue[0].value,
            endYear: dropDownRetrue[dropDownRetrue?.length-1].value
         });
         }
         }
         
         // return dropDownRetrue;
      } catch (error) {
         console.log(error);
         return dropDownRetrue;
      }
   };

   fetchListAbstainTimeForEmployee = async () => {
      const { token } = getToken()
      const { client, location, match } = this.props;
      const { offset, limit, pageData, disabledDateStart, endStartValues, loginPerson } = this.state;

      await this.setState({
         loading: true,
      });

      console.log("fetchListAbstainTimeForEmployee pageData",offset)

      let searchKeyword ={
         empCode :loginPerson.employeeCodes[0],
         isNotBo: true
      }
      const API_DEVICE_KEY = atob(apiKeyNews())

      const headers = {
         'Content-Type': 'application/json',
         'Authorization': `Bearer ${token}`,
         'apiKey': API_DEVICE_KEY
       }

      axios.post(`${UrlAbstainTime()}/fetchListAbstainTimeForEmployee`,{
        args:{
         ...pageData,
         searchKeyword
        } 
      },
      {
         headers: headers
      })
      .then(async (response) => {
         console.log('response.data', response.data)
         await this.setState({
            dataTalbe: response.data.data.data,
            loadingFullpage: false,
            loading: false,
            pagination: {
               total: response.data.data.total,
             },
         })
      }).catch(
         error => console.error(`Error: ${error}`)
      )
   };

   fetchListAbstainTimeForEmployeeSearch = async (valueSearch) => {
      const { token } = getToken()
      const { client, location, match } = this.props;
      const { offset, limit, pageData, disabledDateStart, endStartValues, loginPerson } = this.state;

      await this.setState({
         loading: true,
      });

      let searchKeyword ={
         empCode :loginPerson.employeeCodes[0],
         isNotBo: true,
         ...valueSearch
      }

      console.log("searchKeywords",searchKeyword)
      const API_DEVICE_KEY = atob(apiKeyNews())

      const headers = {
         'Content-Type': 'application/json',
         'Authorization': `Bearer ${token}`,
         'apiKey': API_DEVICE_KEY
       }

      axios.post(`${UrlAbstainTime()}/fetchListAbstainTimeForEmployee`,{
        args:{
         ...pageData,
         searchKeyword
        } 
      },
      {
         headers: headers
      })
      .then(async (response) => {
         console.log('response.data', response.data)
         await this.setState({
            dataTalbe: response.data.data.data,
            loadingFullpage: false,
            loading: false,
            currentPage: 1,
         })
      }).catch(
         error => console.error(`Error: ${error}`)
      )
   };

   fetchListAbstainTimeForEmployeeSearchPagi = async (valueSearch) => {
      const { token } = getToken()
      const { client, location, match } = this.props;
      const { offset, limit, pageData, disabledDateStart, endStartValues, loginPerson } = this.state;

      await this.setState({
         formValue: valueSearch,
         loading: true,
      });

      let searchKeyword ={
         empCode :loginPerson.employeeCodes[0],
         isNotBo: true,
         ...valueSearch
      }

      console.log("searchKeywords",searchKeyword)
      const API_DEVICE_KEY = atob(apiKeyNews())

      const headers = {
         'Content-Type': 'application/json',
         'Authorization': `Bearer ${token}`,
         'apiKey': API_DEVICE_KEY
       }

      axios.post(`${UrlAbstainTime()}/fetchListAbstainTimeForEmployee`,{
        args:{
         offset : 0,
         limit: 10,
         searchKeyword
        } 
      },
      {
         headers: headers
      })
      .then(async (response) => {
         console.log('response.data', response.data)
         await this.setState({
            dataTalbe: response.data.data.data,
            loadingFullpage: false,
            loading: false,
            currentPage: 1,
            pagination: {
               total: response.data.data.total,
             },
         })
      }).catch(
         error => console.error(`Error: ${error}`)
      )
    };


  async componentDidMount() {
    await this.fetchProfile();
    await this.fetchDropDownMasterData("abstainTimeStatus");
    await this.fetchListAbstainTimeForEmployee()
    // await this.dropdownLeaveType()
  }

  render() {
    const { match } = this.props;
    const {
      currentPage,
      dataTalbe,
      columns,
      loading,
      pagination,
      valuesEndDate,
      disabledDateStart,
      endStartValues,
      preLoadSubmit,
      dropdownLeaveType,
      ddStartYear,
      ddEndYear,
      loadingFullpage,
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    console.log("sssdataTalbe", dataTalbe);
    return (
      <Container match={match}>
        <div className="breadcrumb-custom pb-3 mb-5">
          {/* <Breadcrumb.Item> */}
          <span style={{ fontSize: "18px" }}>
            การแก้ไขการลงเวลาทำงาน / รายการขอแก้ไขการลงเวลาทำงาน{" "}
          </span>
          {/* </Breadcrumb.Item> */}
        </div>
        <Spin spinning={loadingFullpage} delay={0}>
        <div className="card-container" id="page-profile">
          <div className="px-5 py-1 card-bg-green">
            <Form onSubmit={this.handleSubmit}>
              <Row
                gutter={16}
                type="flex"
                justify="left"
                align="top"
                className="box-color-white mb-0"
              >
                <Col xs={24} md={24} className="pt-2  mb-3">
                  <strong className="color-red">ค้นหา</strong>
                </Col>
                <Col xs={24} md={12}>
                     <Form.Item label={"เลขที่เอกสาร"}>
                           { getFieldDecorator("documentNo", {
                              initialValue: '',
                              rules:  [{ 
                                 required:false, 
                              }],
                           })(
                              <Input 
                                 className='block-news' 
                              />
                           )}
                     </Form.Item>
                  </Col>


                  <Col xs={ 24 } md={12} >
                     <Form.Item label={"สถานะ"}>
                        { getFieldDecorator("approveStatus", {
                           initialValue: "",
                           rules:  [{ 
                              message: 'กรุณากรอกหรือเลือก สถานะ',
                           }],
                        })(
                           <Select 
                           //onChange={(e) => this.onChangeStatus(e)} 
                           showSearch
                           style={{ width: "100%", borderRadius: "2px 2px 0 0;" }}
                           placeholder="กรุณาเลือก สถานะ"
                           optionFilterProp="children"
                           className="input-select-border-create">
                              <Option value="">ทั้งหมด</Option>
                              {this.state.dropDownTypeabstainTimeStatus &&
                              this.state.dropDownTypeabstainTimeStatus.map(
                                (values, keys) => (
                                  <Option value={values.value} key={keys}>
                                    {values.label}
                                  </Option>
                                )
                              )}
              </Select>
                        )}
                     </Form.Item>
                  </Col>

               
                <Col xs={24} md={24} align={"right"}>
                  <Button
                    type="primary"
                    id="btn-onsearch"
                    className="ml-2 color-white"
                    htmlType="submit"
                    disabled={preLoadSubmit}
                  >
                    ค้นหา
                  </Button>
                  {preLoadSubmit && <Spin size="small" />}
                </Col>
              </Row>
            </Form>
          </div>
          <div className="px-5 py-1 card-bg-green">
            <Row
              gutter={16}
              type="flex"
              justify="left"
              align="top"
              className="box-color-white"
            >
              <Col xs={24} md={12} className="pt-2 mb-3">
                <strong className="color-red">รายการขอแก้ไขการลงเวลาทำงาน</strong>
              </Col>
              <Col xs={24} md={24} align={"center"}>
                {
                  <Table
                    locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
                    dataSource={dataTalbe}
                    columns={columns}
                    loading={loading}
                    // scroll={{ x: 'max-content' }}
                    // pagination={pagination}
                    // pagination={{ pageSize: dataTalbe.length }}
                    scroll={{ x: "max-content", y: "550px" }}
                    pagination={{
                      total: pagination.total,
                      current: currentPage,
                      showSizeChanger: false,
                    }}
                    onChange={this.paginationChange}
                    // onChange={this.paginationChange}
                    // rowCount={dataTalbe.length}
                  />
                }
              </Col>
            </Row>
          </div>
        </div>
        </Spin>
      </Container>
    );
  }
}

Dashboard.defaultProps = {
  autoFocus: false,
};

Dashboard.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedDashboard = Form.create()(Dashboard);

export default withApollo(WrappedDashboard);
